export enum FeatureFlagsEnum {
  VIEW_SECTION_BREADCRUMBS = 'view-section-breadcrumbs',
  FEATURE_INERTIA_INPUTS = 'feature-inertia-inputs',
  FEATURE_INVERTER_LOSS_MAP = 'feature-inverter-loss-map',
  FEATURE_THERMAL_MODEL = 'feature-thermal-model',
}
